<template>
  <v-card elevation="3" color="pwt_snow">
    <v-card-title class="mb-5">
      <v-icon color="primary" class="mr-3"> mdi-piggy-bank-outline </v-icon>
      <span
        style="
          font-family: 'Public Sans';
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px;
          letter-spacing: -0.4px;
        "
      >
        ${{
          (
            (oneYearProjections.totalEquivalentFuelCost +
              (calcVs === 'PETROL'
                ? oneYearProjections.totalPetrolRoadUserCharges
                : oneYearProjections.totalDieselRoadUserCharges) +
              oneYearProjections.totalPetrolMaintenanceCost -
              oneYearProjections.totalPublicChargingCost -
              oneYearProjections.totalPrivateChargingCost -
              oneYearProjections.totalEVMaintenanceCost -
              oneYearProjections.totalElectricRoadUserCharges) *
            years
          ).toLocaleString()
        }} total savings
      </span>
    </v-card-title>
    <v-card-text>
      Estimated savings over 5 years
      <v-card class="bg-background d-flex align-center" flat style="margin-top: 10px; padding: 5px">
        <v-icon color="primary" class="ml-2 mr-2" size="18"> custom:fireIcon </v-icon>
        <span style="font-size: 10pt">
          {{ Math.round(oneYearProjections.totalAvoidedEmissions * years).toLocaleString() }}
          kg CO₂ emissions avoided
        </span>
      </v-card>
      <v-card class="bg-background d-flex align-center" flat style="margin-top: 10px; padding: 5px">
        <v-icon color="primary" class="ml-2 mr-2" icon="custom:pliers" size="18" />
        <span style="font-size: 10pt">
          ${{
            (
              (oneYearProjections.totalPetrolMaintenanceCost -
                oneYearProjections.totalEVMaintenanceCost) *
              years
            ).toLocaleString()
          }}
          maintenance savings
        </span>
      </v-card>
      <v-card class="bg-background d-flex align-center" flat style="margin-top: 10px; padding: 5px">
        <v-icon color="primary" class="ml-2 mr-2" icon="custom:waterDrop" size="18" />
        <span style="font-size: 10pt">
          ${{
            (
              (oneYearProjections.totalEquivalentFuelCost +
                oneYearProjections.totalPublicChargingCost -
                oneYearProjections.totalPrivateChargingCost) *
              years
            ).toLocaleString()
          }}
          fuel savings
        </span>
      </v-card>
      <OutlinedBlockBtn class="mt-5 mb-2 rounded-pill text-truncate" @click="toSavedTrips">
        {{ mobile ? 'See all saved trips & savings' : 'See all saved trips & estimated savings' }}
      </OutlinedBlockBtn>
    </v-card-text>
  </v-card>
</template>
<script setup lang="ts">
import OutlinedBlockBtn from '@/components/ui-elements/buttons/OutlinedBlockBtn.vue'
import { GettersTypes, MutationTypes } from '@/store/store_types'
import { computed, ref } from 'vue'
import { useDisplay } from 'vuetify'
import { useStore } from 'vuex'

const store = useStore()

const oneYearProjections = computed(() => store.getters[GettersTypes.getOneYearProjections])
const calcVs = computed(() => store.state.calcVs)

const years = ref(5)

function toSavedTrips() {
  store.commit(MutationTypes.setDashboardDialogContent, 'saved-trips')
  store.commit(MutationTypes.setShowDashboard, true)
}

const { mobile } = useDisplay()
</script>
